import axios from 'axios';
import router from '../router';
import Message from './message'
import cache from '@/plugins/cache'

axios.defaults.timeout = 3000000;

//http request 拦截器
axios.interceptors.request.use(
	config => {
		config.data = JSON.stringify(config.data);
		let token = '';
		if (localStorage.getItem('token')) {
			token = JSON.parse(localStorage.getItem('token'));
		} else if (config.url.indexOf('token=') > -1) {
			token = config.url.split('token=')[1];
		}
		// 是否需要防止数据重复提交
		const isRepeatSubmit = true;
		config.headers = {
			'X-Requested-With': 'XMLHttpRequest',
			'Content-Type': 'application/json; charset=UTF-8',
			token : token
		}

		if (isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
			const requestObj = {
				url: config.url,
				data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
				time: new Date().getTime()
			}
			const requestSize = Object.keys(JSON.stringify(requestObj)).length; // 请求数据大小
			const limitSize = 5 * 1024 * 1024; // 限制存放数据5M
			if (requestSize >= limitSize) {
				console.warn(`[${config.url}]: ` + '请求数据大小超出允许的5M限制，无法进行防重复提交验证。')
				return config;
			}
			const sessionObj = cache.session.getJSON('sessionObj')
			if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
				cache.session.setJSON('sessionObj', requestObj)
			} else {
				const s_url = sessionObj.url;                // 请求地址
				const s_data = sessionObj.data;              // 请求数据
				const s_time = sessionObj.time;              // 请求时间
				const interval = 1000;                       // 间隔时间(ms)，小于此时间视为重复提交
				if (s_data === requestObj.data && requestObj.time - s_time < interval && s_url === requestObj.url) {
					const message = '数据正在处理，请勿重复提交';
					// console.warn(`[${s_url}]: ` + message)
					
					return Promise.reject(new Error(message))
				} else {
					cache.session.setJSON('sessionObj', requestObj)
				}
			}
		}
		return config;
	},
	error => {
		return Promise.reject(error);
	}
);

//响应拦截器即异常处理
axios.interceptors.response.use(response => {
	if( response.data.code == 1000) {
		setTimeout(() => {
			localStorage.clear();
			sessionStorage.clear();
			router.push({ path: '/Login' });
		}, 1000);
	}
	response => {
		if (response.status == 200) {
			return Promise.resolve(response);
		} else {
			return Promise.reject(response);
		}
	}
	return response
}, err => {
	if (err && err.response) {
	  switch (err.response.status) {
		case 400:
			Message({
				message: '错误请求!',
				type: 'error'
			});
			break;
		case 401:
			Message({
				message: '未授权，请重新登录!',
				type: 'error'
			});
			break;
		case 403:
			Message({
				message: '拒绝访问!',
				type: 'error'
			});
			break;
		case 404:
			Message({
				message: '请求错误,未找到该资源!',
				type: 'error'
			});
			break;
		case 405:
			Message({
				message: '请求方法未允许!',
				type: 'error'
			});
			break;
		case 408:
			Message({
				message: '请求超时!',
				type: 'error'
			});
			break;
		case 500:
			Message({
				message: '服务器端出错!',
				type: 'error'
			});
			break;
		case 501:
			Message({
				message: '网络未实现!',
				type: 'error'
			});
			break;
		case 502:
			Message({
				message: '网络错误!',
				type: 'error'
			});
			break;
		case 503:
			Message({
				message: '服务不可用!',
				type: 'error'
			});
			break;
		case 504:
			Message({
				message: '网络超时!',
				type: 'error'
			});
			break;
		case 505:
			Message({
				message: 'http版本不支持该请求!',
				type: 'error'
			});
			break;
		default:
			console.log(`连接错误${err.response.status}`)
	  }
	} else {
		// 解析 Promise.reject(new Error(message)) 错误
		let err_res = err.toString()
		if (err_res.indexOf('Error: ') === 0) {
			err_res = err_res.substring(7)
		}
		if (err_res !== '数据正在处理，请勿重复提交') {
			Message({
				message: '连接服务器失败,检测到您本地网络存在问题,请检查网络设置或者本地防火墙设置！',
				type: 'error'
			});
		}
		
	}
	return Promise.reject(err.response)
})


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url,params={}){
	return new Promise((resolve,reject) => {
		axios.get(url,{
			params: params
		})
		.then(response => {
			if(response.data == ''){
				router.push({ path: '/Login' });
			}else{
				resolve(response);
			}
		})
		.catch(function(reason) {
			reject(reason)
		})
	})
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url,data,config){
	return new Promise((resolve,reject) => {    
		axios.post(url,data,config)
		.then(response => {
			resolve(response);
		},err => {
			reject(err)
		}).catch(err => {
			reject(err.data)
		})
	})
}

 /**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url,data = {}){
	return new Promise((resolve,reject) => {
		axios.patch(url,data)
		.then(response => {
			resolve(response.data);
		},err => {
			reject(err)
		})
	})
}

 /**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url,data = {}){
	return new Promise((resolve,reject) => {
		axios.put(url,data)
			.then(response => {
			resolve(response.data);
		},err => {
			reject(err)
		})
	})
}




// WEBPACK FOOTER //
// ./src/api/axios.js